import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({ store: 'shared', prop: 'batchAllocationDefaultHeaders' })
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: "ID",
          align: "left",
          value: "id",
          type: "text"
        },
        {
          text: "Date",
          align: "left",
          value: "date",
          type: "date"
        },
        {
          text: "Project",
          align: "left",
          value: "site.project.name",
          type: "text"
        },
        {
          text: "Site",
          align: "left",
          value: "site.name",
          type: "text"
        },
        {
          text: "Day / Night",
          align: "center",
          value: "day",
          type: "dayBool"
        },
        {
          text: "Lines",
          align: "left",
          value: "lineCount",
          type: "num"
        },
        {
          text: "Created By",
          align: "left",
          value: "createdBy.name",
          type: "text"
        },
      ],
      actions: [
        {
          text: "Confirm Tip",
          icon: this.$store.state.global.pages.tipping.icon,
          color: "green lighten-2",
          value: {
            field: "tipConfirmed",
            value: "CONFIRMED",
            text: "Confirm Tip",
            label: "tip"
          }
        },
        {
          text: "Review Tip",
          icon: this.$store.state.global.pages.tipping.icon,
          color: "orange lighten-2",
          value: {
            field: "tipConfirmed",
            value: "REVIEW",
            text: "Review Tip",
            label: "tip"
          }
        },
        {
          text: "Unconfirm Tip",
          icon: this.$store.state.global.pages.tipping.icon,
          color: "grey",
          value: {
            field: "tipConfirmed",
            value: "NOT SET",
            text: "Un-confirm Tip",
            label: "tip"
          }
        },
        {
          text: "Confirm Site",
          icon: this.$store.state.global.pages.site.icon,
          color: "green lighten-2",
          value: {
            field: "siteConfirmed",
            value: "CONFIRMED",
            text: "Confirm Site",
            label: "site"
          }
        },
        {
          text: "Review Site",
          icon: this.$store.state.global.pages.site.icon,
          color: "orange lighten-2",
          value: {
            field: "siteConfirmed",
            value: "REVIEW",
            text: "Review Site",
            label: "site"
          }
        },
        {
          text: "Unconfirm Site",
          icon: this.$store.state.global.pages.site.icon,
          color: "grey",
          value: {
            field: "siteConfirmed",
            value: "NOT SET",
            text: "Unconfirm Site",
            label: "site"
          }
        },
        {
          text: "Confirm Amendments",
          icon: "post_add",
          color: "green lighten-2",
          value: {
            field: "amendmentsConfirmed",
            value: "CONFIRMED",
            text: "Confirm Amendments",
            label: "amendments"
          }
        },
        {
          text: "Review Amendments",
          icon: "post_add",
          color: "orange lighten-2",
          value: {
            field: "amendmentsConfirmed",
            value: "REVIEW",
            text: "Review Amendments",
            label: "amendments"
          }
        },
        {
          text: "Unconfirm Amendments",
          icon: "post_add",
          color: "grey",
          value: {
            field: "amendmentsConfirmed",
            value: "NOT SET",
            text: "Unconfirm Amendments",
            label: "amendments"
          }
        },
        {
          text: "Export Selected (CSV)",
          icon: "import_export",
          color: "grey",
          value: { value: null, text: "Export Selected (CSV)", label: "export" }
        }
      ]
    }
  }
}